import { render, staticRenderFns } from "./confirmDeletionModal.vue?vue&type=template&id=dba3e6aa"
import script from "./confirmDeletionModal.vue?vue&type=script&lang=js"
export * from "./confirmDeletionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports